import { ENTER_CODE, ESC_CODE, TAB_CODE, USD_KEY_CODE } from '../constants/keycodes'

export const isDollar = ({ keyCode, isShift }) => keyCode === USD_KEY_CODE && isShift
export const isEnter = ({ keyCode }) => keyCode === ENTER_CODE
export const isESC = ({ keyCode }) => keyCode === ESC_CODE
export const isTab = ({ keyCode }) => keyCode === TAB_CODE
